import React from 'react';

import { useAppContext } from '@contexts/AppContext';
import { useCurrentNewsletterSubscription } from '@hooks';
import { Newsletter } from '@utils/backend-api/newsletters';

import Footer from './Footer';
import Header from './Header';
import Middle from './Middle';

const HEADER = 'header';
const MIDDLE = 'middle';
const FOOTER = 'footer';

interface ContentProps {
  newsletter: Newsletter;
  feedType: string;
}

const Content = ({ newsletter, feedType }: ContentProps) => {
  const { id } = newsletter;
  const { isGdprRequired, initialCurrentUser } = useAppContext();
  const { isSubscribed } = useCurrentNewsletterSubscription(id);
  const isLoggedIn = !!initialCurrentUser;

  const renderFeed = () => {
    switch (feedType) {
      case HEADER:
        return <Header isSubscribed={isSubscribed} newsletter={newsletter} />;
      case MIDDLE:
        return (
          <Middle
            currentUserAccessLevel={initialCurrentUser?.access_level ?? 0}
            isLoggedIn={isLoggedIn}
            isSubscribed={isSubscribed}
            gdpr={isGdprRequired}
            newsletter={newsletter}
          />
        );
      case FOOTER:
        return (
          <Footer
            currentUserAccessLevel={initialCurrentUser?.access_level ?? 0}
            isLoggedIn={isLoggedIn}
            isSubscribed={isSubscribed}
            gdpr={isGdprRequired}
            newsletter={newsletter}
          />
        );
      default:
        console.error('Unknown Feed Type');
    }
  };
  return renderFeed();
};

export default Content;
